import { faHistory } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { IconButton } from '@mui/material'
import { createMRTColumnHelper, MRT_ColumnDef } from 'material-react-table'
import { useMemo } from 'react'

import { TextCell } from '@/components'
import { createHeaderWithTooltip } from '@/components/MrtTable/helpers'
import { useAppContext } from '@/hooks'
import { HistoryDto } from '@/rtkApi/mddApiSliceGenerated'

export type UseVersionsTableColumnsOptions = {
	onOpenDiff?: (version: number) => void
}

export const useVersionsTableColumns = (
	options?: UseVersionsTableColumnsOptions,
) => {
	const { t } = useAppContext()
	const { onOpenDiff } = options ?? {}

	const columnHelper = createMRTColumnHelper<HistoryDto>()

	const columns = useMemo(
		() => [
			columnHelper.accessor('version', {
				...createHeaderWithTooltip(t('TABLE_GENERAL_VERSION')),
				size: 50,
				Edit: ({ cell, table, row, column }) => (
					<TextCell
						cell={cell}
						column={column}
						table={table}
						row={row}
						isReadOnly
					/>
				),
			}),
			columnHelper.accessor('created', {
				...createHeaderWithTooltip(t('TABLE_GENERAL_DATE')),
				Edit: ({ cell, table, row, column }) => (
					<TextCell
						cell={cell}
						column={column}
						table={table}
						row={row}
						isReadOnly
					/>
				),
			}),
			columnHelper.accessor('authorName', {
				...createHeaderWithTooltip(t('TABLE_GENERAL_AUTHOR')),
				Edit: ({ cell, table, row, column }) => (
					<TextCell
						cell={cell}
						column={column}
						table={table}
						row={row}
						isReadOnly
					/>
				),
			}),
			columnHelper.accessor('description', {
				...createHeaderWithTooltip(t('TABLE_COLUMNS_DESCRIPTION')),
				Edit: ({ cell, table, row, column }) => (
					<TextCell
						cell={cell}
						column={column}
						table={table}
						row={row}
						isReadOnly
					/>
				),
			}),
			...(onOpenDiff
				? [
						columnHelper.display({
							id: 'actions',
							...createHeaderWithTooltip(t('ACTIONS')),
							size: 60,
							enableEditing: false,
							Cell: ({ row }) => (
								<IconButton
									size="small"
									onClick={() => onOpenDiff(row.original.version)}
									aria-label={t('VERSIONS')}
									data-testid={`version-diff-${row.original.version}`}
								>
									<FontAwesomeIcon
										title={t('VERSIONS')}
										icon={faHistory}
									/>
								</IconButton>
							),
						}),
					]
				: []),
		],
		[columnHelper, t, onOpenDiff],
	)

	return columns as MRT_ColumnDef<HistoryDto>[]
}
